import React from 'react'
import {Button, Label, Input, Icon, Form} from 'semantic-ui-react'

class PickList extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      newSelectionValue: '',
      pickListItems: this.props.pickListItems ? this.props.pickListItems : []
    }
  }
  handleKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.props.handlePickListAddClick()
    }
  }

  render () {
    return (
      <div>
        <h3>Single select</h3>
        <div>
          <Form.Group inline>
            <Form.Field>
              <label>Option</label>
              <Input onChange={this.props.onPickListFieldChange.bind(this)} value={this.props.newSelectionValue} onKeyPress={this.handleKeyPress.bind(this)} />
            </Form.Field>
            <Button type='button' onClick={this.props.handlePickListAddClick}>Add option</Button>
          </Form.Group>
        </div>
        <div>
          {this.props.pickListItems.map(item => {
            return (<Label key={item} image>
              {item}
              <Icon name='delete' onClick={() => { this.props.onPickListItemDelete(item) }} />
            </Label>)
          })}
        </div>
        <br />
      </div>
    )
  }
}

export default PickList



// WEBPACK FOOTER //
// ./src/pages/settings/template-customisation/components/PickList.js